/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UpdateUserAccountName200ResponseAvailableMerchantCategoriesInner } from './update-user-account-name200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateUserAccountName200ResponseReissue } from './update-user-account-name200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateUserAccountName200ResponseUser } from './update-user-account-name200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateUserAccountName200ResponseUserAccountGroup } from './update-user-account-name200-response-user-account-group';

/**
 * 
 * @export
 * @interface UpdateUserAccountName200Response
 */
export interface UpdateUserAccountName200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserAccountName200Response
     */
    'availableCurrencies': Array<UpdateUserAccountName200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateUserAccountName200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateUserAccountName200Response
     */
    'availableMerchantCategories': Array<UpdateUserAccountName200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateUserAccountName200ResponseUser}
     * @memberof UpdateUserAccountName200Response
     */
    'user': UpdateUserAccountName200ResponseUser;
    /**
     * 
     * @type {UpdateUserAccountName200ResponseUserAccountGroup}
     * @memberof UpdateUserAccountName200Response
     */
    'userAccountGroup'?: UpdateUserAccountName200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {UpdateUserAccountName200ResponseReissue}
     * @memberof UpdateUserAccountName200Response
     */
    'reissue'?: UpdateUserAccountName200ResponseReissue | null;
}

export const UpdateUserAccountName200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateUserAccountName200ResponseAvailableCurrenciesEnum = typeof UpdateUserAccountName200ResponseAvailableCurrenciesEnum[keyof typeof UpdateUserAccountName200ResponseAvailableCurrenciesEnum];


